import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  GetClaimedVoucherResponse,
  GetPaymentTypeResponse,
  GetPaymentWindowsResponseItem,
  GetStudentPaymentHistoryResponseItem,
  PostPaymentRequestBody,
} from './payment.types';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  rootUrl = environment.urls.studentPortalAPIUrl;

  constructor(private http: HttpClient) {}

  validateStudentPayment() {
    return this.http.get<boolean>(`${this.rootUrl}/v1/payment/validate`);
  }

  getPaymentType(institutionId: number) {
    return this.http.get<GetPaymentTypeResponse>(
      `${this.rootUrl}/v1/payment/student/${institutionId}/paytype`
    );
  }

  getPaymentWindows(institutionId: number) {
    return this.http.get<GetPaymentWindowsResponseItem[]>(
      `${this.rootUrl}/v1/payment/paywindow/${institutionId}`
    );
  }

  getStudentPaymentWindows(institutionId: number, studentId: number) {
    return this.http.get<GetStudentPaymentHistoryResponseItem[]>(
      `${this.rootUrl}/v1/payment/student/${institutionId}/${studentId}`
    );
  }

  claimVoucher(studentUserId: number, code: string) {
    return this.http.post(`${this.rootUrl}/v1/payment/voucher/claim`, {
      studentUserId,
      code,
    });
  }

  getVoucherByCode(code: string) {
    return this.http.get<GetClaimedVoucherResponse>(
      `${this.rootUrl}/v1/payment/voucher/${code}/view`
    );
  }

  postPayment(body: PostPaymentRequestBody) {
    return this.http.post(`${this.rootUrl}/v1/payment/directpay/paid`, body);
  }
}
